var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuoy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.577,
    height: 83.289,
    viewBox: "0 0 80.577 83.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2637",
    x: 0,
    y: 2.711,
    width: 80.577,
    height: 80.578,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BOUEE",
    transform: "translate(-1481.188 -902)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1344",
    "data-name": "Rectangle 1344",
    width: 80,
    height: 80,
    rx: 20,
    transform: "translate(1481.477 902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bou\\xE9e",
    transform: "translate(1490.188 910.711)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -8.71)",
    filter: "url(#Path_2637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2637-2",
    "data-name": "Path 2637",
    d: "M66.448,150.833A31.289,31.289,0,1,1,35.16,182.122a31.294,31.294,0,0,1,31.288-31.289Zm0,14.461a16.828,16.828,0,1,1-16.827,16.828,16.825,16.825,0,0,1,16.827-16.828Z",
    transform: "translate(-26.16 -142.12)",
    fill: "#eaebeb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M69.383,168.587a18.459,18.459,0,1,1-18.451,18.467,18.475,18.475,0,0,1,18.451-18.467Zm.9,1.02a16.828,16.828,0,1,1-16.827,16.828A16.825,16.825,0,0,1,70.28,169.608Z",
    transform: "translate(-38.992 -155.146)",
    fill: "#d7d8d8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M66.448,150.833a31.809,31.809,0,0,1,8.1,1.052l-3.759,13.981a16.8,16.8,0,0,0-12.759,1.686L50.8,155.025a31.2,31.2,0,0,1,15.652-4.192Zm27.1,15.637a31.311,31.311,0,0,1,3.124,23.756L82.7,186.483a16.954,16.954,0,0,0,.572-4.361,16.7,16.7,0,0,0-2.258-8.414ZM82.1,209.219a31.311,31.311,0,0,1-23.756,3.124l3.743-13.966a16.872,16.872,0,0,0,4.361.572,16.7,16.7,0,0,0,8.414-2.258ZM39.351,197.774a31.039,31.039,0,0,1-4.191-15.652,31.8,31.8,0,0,1,1.052-8.1l13.982,3.743a16.926,16.926,0,0,0-.572,4.361,16.7,16.7,0,0,0,2.258,8.414Z",
    transform: "translate(-35.16 -150.833)",
    fill: "#dc291b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M74.843,169.407l-.217.773a16.8,16.8,0,0,0-12.759,1.686l-.759-1.314a18.378,18.378,0,0,1,8.275-1.965,18.723,18.723,0,0,1,5.46.82Zm10.487,8.336a18.443,18.443,0,0,1,2.521,9.311,18.783,18.783,0,0,1-.433,3.975l-.882-.232a16.954,16.954,0,0,0,.572-4.361,16.7,16.7,0,0,0-2.258-8.414Zm-5.8,24.731a18.344,18.344,0,0,1-10.146,3.031,18.913,18.913,0,0,1-4.1-.448l.634-2.367a16.872,16.872,0,0,0,4.361.572A16.7,16.7,0,0,0,78.694,201ZM53.36,196.21a18.544,18.544,0,0,1-1.578-14.724l2.243.587a16.926,16.926,0,0,0-.572,4.361,16.7,16.7,0,0,0,2.258,8.414Z",
    transform: "translate(-38.992 -155.146)",
    fill: "#c12012",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuoy);
export default __webpack_public_path__ + "static/media/buoy.5e1100f0.svg";
export { ForwardRef as ReactComponent };